var map = {
	"./Revised-Landing-Page": 6309,
	"./Revised-Landing-Page.png": 6309,
	"./arch": 4853,
	"./arch.png": 4853,
	"./bb_logo": 6268,
	"./bb_logo.png": 6268,
	"./bookface": 4472,
	"./bookface.png": 4472,
	"./brain.jpg": 6704,
	"./bricks": 9773,
	"./bricks-red": 8973,
	"./bricks-red-grunged": 3898,
	"./bricks-red-grunged.png": 3898,
	"./bricks-red-lighter": 651,
	"./bricks-red-lighter.png": 651,
	"./bricks-red.png": 8973,
	"./bricks.png": 9773,
	"./bricks2": 5090,
	"./bricks2.png": 5090,
	"./bricksred": 9477,
	"./bricksred.png": 9477,
	"./bricksred1": 3469,
	"./bricksred1.png": 3469,
	"./daily_deals": 7284,
	"./daily_deals.png": 7284,
	"./fire": 1308,
	"./fire.png": 1308,
	"./food": 7923,
	"./food.png": 7923,
	"./grunge": 9331,
	"./grunge.png": 9331,
	"./header": 2511,
	"./header.png": 2511,
	"./house": 4750,
	"./house.png": 4750,
	"./logo": 3151,
	"./logo.png": 3151,
	"./outside.jpg": 8964,
	"./p": 3720,
	"./p.png": 3720,
	"./p_lighter": 2346,
	"./p_lighter.png": 2346,
	"./pastrami": 285,
	"./pastrami.png": 285,
	"./pause": 4005,
	"./pause.png": 4005,
	"./pdf": 2563,
	"./pdf.png": 2563,
	"./picture-frame": 6953,
	"./picture-frame.png": 6953,
	"./picture_01.jpg": 6792,
	"./picture_02.jpg": 2348,
	"./picture_03.jpg": 513,
	"./picture_04.jpg": 6930,
	"./picture_05.jpg": 416,
	"./picture_06.jpg": 6757,
	"./picture_07.jpg": 1629,
	"./picture_08.jpg": 4979,
	"./picture_09.jpg": 8961,
	"./picture_10.jpg": 3912,
	"./picture_11.jpg": 8427,
	"./picture_12.jpg": 2520,
	"./picture_13.jpg": 4833,
	"./picture_14.jpg": 379,
	"./picture_15.jpg": 2566,
	"./picture_16.jpg": 9182,
	"./picture_17.jpg": 5308,
	"./picture_18.jpg": 605,
	"./picture_19.jpg": 356,
	"./picture_20.jpg": 5510,
	"./play": 5518,
	"./play.png": 5518,
	"./qype": 6164,
	"./qype.png": 6164,
	"./random-stars": 6045,
	"./random-stars.png": 6045,
	"./ribs.jpg": 9024,
	"./white-star": 6789,
	"./white-star.png": 6789,
	"./yelp": 9552,
	"./yelp.png": 9552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4550;